import { render, staticRenderFns } from "./IndustryPostMain.vue?vue&type=template&id=6b11c47a&"
import script from "./IndustryPostMain.vue?vue&type=script&lang=js&"
export * from "./IndustryPostMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports